var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 60c-80 79-80 208 0 287 79 79 208 79 287 0s79-208 0-287c-79-80-208-80-287 0zm152 236c0 5-4 9-9 9-4 0-8-4-8-9v-84h-85c-5 0-8-4-8-9 0-4 3-8 8-8h85v-85c0-5 4-8 8-8 5 0 9 3 9 8v85h84c5 0 9 4 9 8 0 5-4 9-9 9h-84v84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleFilled);
export default __webpack_public_path__ + "static/media/AddCircleFilled.8f050ea2927b5843162ecceaa3c845f5.svg";
export { ForwardRef as ReactComponent };